// This file manages exports from the base atom, molecule, or organism.
// Use named rather than default exports.
import { EditableComponent } from '@adobe/aem-react-editable-components';
import dynamic from 'next/dynamic';

// This file manages exports from the base atom, molecule, or organism.
// Use named rather than default exports.
const PromotionBanner = dynamic(() => import('./PromotionBanner').then(mod => mod.PromotionBanner));

export const PromotionBannerConfig = {
  emptyLabel: 'promotionbanner',
  isEmpty: false,
  resourceType: `mi-aem-account/components/content/promotionbanner`,
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const PromotionBannerEditable = (props: any) => {
  return (
    <EditableComponent config={PromotionBannerConfig} {...props}>
      <PromotionBanner {...props} />
    </EditableComponent>
  );
};
